import { render, staticRenderFns } from "./SubmenuHeading.vue?vue&type=template&id=bab8ffb8&"
import script from "./SubmenuHeading.vue?vue&type=script&lang=ts&"
export * from "./SubmenuHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports